import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const importUserSlice = getBulkActionSlice(
    'importUserResult',
);

export const selectImportUserUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.importUserResult.uuid;

export const selectImportUserShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.importUserResult.shown;

export const selectImportUserTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.importUserResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = importUserSlice.actions;
